import $ from 'jquery'

const className = "key-focus-visible"
const onKeyboardAction = (e) => {
  document.documentElement.classList.add(className)
}
const onMouseAction = (e) => {
  document.documentElement.classList.remove(className)
}

export const initFocusVisible = () => {
  $("body").on("keydown", onKeyboardAction)
  $("body").on("click", onMouseAction)
}